// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFileUrlDto
 */
export interface IFileUrlDto {
    /**
     * 
     * @type {number}
     * @memberof IFileUrlDto
     */
    file_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IFileUrlDto
     */
    url?: string;
}

/**
 * Check if a given object implements the IFileUrlDto interface.
 */
export function instanceOfIFileUrlDto(value: object): value is IFileUrlDto {
    return true;
}

export function IFileUrlDtoFromJSON(json: any): IFileUrlDto {
    return IFileUrlDtoFromJSONTyped(json, false);
}

export function IFileUrlDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFileUrlDto {
    if (json == null) {
        return json;
    }
    return {
        
        'file_id': json['file_id'] == null ? undefined : json['file_id'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function IFileUrlDtoToJSON(json: any): IFileUrlDto {
    return IFileUrlDtoToJSONTyped(json, false);
}

export function IFileUrlDtoToJSONTyped(value?: IFileUrlDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'file_id': value['file_id'],
        'url': value['url'],
    };
}

